<template>
  <f7-page name="vehicles" ptr @ptr:refresh="updateData">
    <f7-navbar title="Správa vozidiel" back-link></f7-navbar>

    <f7-block-title>Moje vozidlá</f7-block-title>
    <f7-list strong inset dividers-ios media-list v-if="vehicles.length">
      <f7-list-item
        v-for="vehicle in vehicles"
        :key="vehicle.ecv"
        :title="vehicle.ecv"
        :subtitle="buildVehicleSubtitle(vehicle)"
        swipeout
        @swipeout:delete="vehicle.deleteVehicle()"
      >
        <template #media>
          <img
            v-if="vehicle.logoUrl"
            :src="vehicle.logoUrl"
            :alt="`Logo značky ${vehicle.brand ?? vehicle.ecv}`"
            loading="lazy"
          />
        </template>

        <f7-swipeout-actions right>
          <f7-swipeout-button delete :confirm-text="beforeDeleteText(vehicle)" close
            >Vymazať</f7-swipeout-button
          >
        </f7-swipeout-actions>
      </f7-list-item>
    </f7-list>

    <f7-block strong inset v-else>
      <p class="text-align-center">Zatiaľ ste nepridali žiadne vozidlo.</p>
    </f7-block>

    <f7-block>
      <f7-button popup-open=".parking-vehicle-form" large tonal color="primary"
        >Pridať vozidlo</f7-button
      >
    </f7-block>

    <template #fixed>
      <Menu />
    </template>
  </f7-page>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type Vehicle from '@/assets/classes/parking/Vehicle'
import Vehicles from '@/assets/classes/parking/Vehicles'
import Menu from '@/components/menu.vue'

const vehicles = computed(() => Vehicles.listVehicles())

const buildVehicleSubtitle = (vehicle: Vehicle) => {
  return [vehicle.brand, vehicle.model].filter(Boolean).join(' ')
}

const updateData = async (done: () => void) => {
  await Vehicles.fetchNewData()
  done()
}

const beforeDeleteText = (vehicle: Vehicle) => {
  return `Chystáte sa odstrániť vozidlo <b>${vehicle.ecv}</b>. Pokračovaním súhlasíte s odstránením.`
}
</script>

<style scoped>
:deep(img) {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
</style>
